import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { WaterwayInputVM } from '../WaterwayInputVM';
import { formatDate } from 'cd-eft/utils/formatDate';
import { Form, FormText, FormGroup, Label, Col, Table, Input } from 'reactstrap';
import { ActionsMenu } from 'cd-eft/components/Design/common/ActionsMenu';
import { Popup } from 'cd-eft/components/common/Popup';
import { Accordion } from 'cd-eft/components/common/Accordion';

import stores from 'cd-eft/models/Stores';
import { DesignCommentDeletePopup } from 'cd-eft/components/Projects/common/CommentInputs';
const designStore = stores.AppStore.designStore;

interface ISubFormProps {
    vm: WaterwayInputVM;
}
const WaterwayInputComments = (props: ISubFormProps) => {

    const vm = useRef(props.vm.waterwayCommentsVM).current;

    useEffect(() => {
        vm.getComments();
    }, [designStore.projectsStore.currentProject.projectUuid])

    return (
        <Accordion
            className={'wdt-comments-control accordion-wrapper'}
            headers={['Comments']}
            actionButton={<ActionsMenu i={'wdt-comments'} item="item" elementActions={vm.elementActions}>Action</ActionsMenu>}
            light={true}
        >

            <div className="wdt-comment-content-container">
                {/********************  Create Comments Form   ********************/}
                {vm.addFormVisible && (
                    /* Create project comments form */
                    <Form fluid={+true}>
                        <FormGroup>
                            <Col>
                                <Label for="createdBy">
                                    <div className="info">
                                        <div className="name">
                                            <strong>{vm.logginUser.split('@')[0].replace('.', ' ')}</strong>
                                        </div>
                                        <div className="date">{formatDate(Date.now())}</div>
                                    </div>
                                </Label>
                            </Col>
                            <Col>
                                <Input
                                    name="waterwayComment"
                                    value={vm.newWaterwayComment.projectComment}
                                    placeholder="add comment"
                                    type="textarea"
                                    autoFocus
                                    onChange={vm.handleInput}
                                    rows={vm.rowHeight}
                                />
                            </Col>
                        </FormGroup>
                    </Form>
                )}
                {vm.addFormVisible && (
                    <div className="d-flex justify-content-end usa-buttons">
                        <button className="usa-button usa-button--outline" onClick={vm.cancelWaterwayComment}>
                            Close
                        </button>
                        <button className="usa-button" onClick={vm.addWaterwayComment}>
                            Save
                        </button>
                    </div>
                )}
                {/********************  End of Create Comments Form   ********************/}

                {/********************  Showing (ReadOnly) Comments Form **************  */}
                {vm.summarizedWaterwayCommentsStore &&
                    vm.summarizedWaterwayCommentsStore.map((comment, i) => {
                        return (
                            <div className="comment-wrapper " key={'key comment -' + i}>

                                {/* Project comment ready only */}
                                {vm.readOnlyForm && (
                                    <Form fluid={+true}>
                                        <FormGroup>
                                            <Col>
                                                <Label for="createdBy">
                                                    <div className="info">
                                                        {vm.deleteFormVisible && (<div className="design-comment-checkbox">
                                                            <input

                                                                id={'delete' + i}
                                                                name='delete'
                                                                aria-label={'delete' + i}
                                                                type="checkbox"
                                                                checked={vm.checkedState[i]}
                                                                data-testid={'delete' + i}
                                                                onChange={(e) => vm.handleDeleteCheckBox(i)}
                                                            />
                                                        </div>
                                                        )}
                                                        <div className="name">
                                                            <strong>{comment.commentAuthor.split('@')[0].replace('.', ' ')}</strong>
                                                        </div>
                                                        <div className="">
                                                            {`${formatDate(comment.lastChangeDateUtc)}`}
                                                        </div>
                                                        {comment.editStatus === 'update' && (
                                                            <div>{`\u00A0- Edited By ${comment.lastChangedBy.split('@')[0].replace('.', ' ')}`}</div>
                                                        )}
                                                    </div>
                                                </Label>
                                            </Col>
                                            <FormText
                                                className="form-text"
                                                readOnly
                                                id={comment.projectElementCommentId.toString()}
                                                value={comment.projectComment}
                                            >
                                                {comment.projectComment}
                                            </FormText>
                                        </FormGroup>
                                    </Form>
                                )}
                                {/********************  End of Showing (ReadOnly) Comments Form **************  */}
                                {/********************  Edit Comments Form   ********************/}
                                {vm.editFormVisible && (
                                    <Form fluid={+true}

                                    // onSubmit={vm.handleSubmit}
                                    >
                                        <FormGroup>
                                            <Col>
                                                <Label for="createdBy">
                                                    <div className="info">
                                                        <div className="design-comment-checkbox">
                                                            <input

                                                                id={'edit' + i}
                                                                name='edit'
                                                                aria-label={'edit' + i}
                                                                type="checkbox"
                                                                checked={vm.checkedState[i]}
                                                                data-testid={'edit' + i}
                                                                onChange={(e) => vm.handleEditCheckBox(i)}
                                                            />
                                                        </div>
                                                        <div className="name">
                                                            <strong>{comment.createdBy}</strong>
                                                        </div>
                                                        <div className="edited-by">
                                                            {`${formatDate(comment.lastChangeDateUtc)}`}
                                                        </div>
                                                        {comment.editStatus === 'edited' && (
                                                            <div>{`\u00A0- Edited By ${comment.lastChangedBy}`}</div>
                                                        )}
                                                    </div>
                                                </Label>
                                            </Col>
                                            {!vm.checkedState[i] && (
                                                <FormText
                                                    className="form-text"
                                                    readOnly
                                                    id={comment.projectUuid}
                                                    value={comment.projectComment}
                                                >
                                                    {comment.projectComment}
                                                </FormText>
                                            )}
                                            {vm.checkedState[i] && (<div className="edit-input">
                                                <textarea
                                                    className={`comment-textarea`}
                                                    id={comment.projectUuid}
                                                    name="projectComment"
                                                    defaultValue={comment.projectComment}
                                                    value={vm.editedWaterwayComment.projectComment}
                                                    placeholder="add comment"
                                                    onChange={(e) => vm.handleEditInputChange(e, i)}
                                                    rows={3}
                                                    wrap="soft"
                                                    autoFocus
                                                />

                                            </div>
                                            )}
                                        </FormGroup>
                                    </Form>
                                )}

                                {vm.editFormVisible && vm.checkedState[i] && (
                                    <div className="d-flex justify-content-end usa-buttons">
                                        <button className="usa-button usa-button--outline" onClick={() => vm.handleEditCancelButton(i)}>
                                            Close
                                        </button>
                                        <button className="usa-button" onClick={() => vm.handleEditSaveButton(i)} >
                                            Save
                                        </button>
                                    </div>
                                )}

                            </div>
                        );
                    })
                }
                {vm.deleteFormVisible && vm.checkedState.some(Boolean) && (
                    <div className="d-flex justify-content-end usa-buttons">
                        <button className="usa-button usa-button--outline" onClick={vm.cancelComment} >
                            Close
                        </button>
                        <button className="usa-button" onClick={vm.toggleDeletePopup}>
                            Delete
                        </button>
                    </div>
                )}

                {/********************  Delete Comments Popup   ********************/}
                <DesignCommentDeletePopup
                    vm={vm}
                    commentList={vm.summarizedWaterwayCommentsStore}
                    nameHeader='Structure Name'
                />
                {/********************  Delete Comments Popup   ********************/}
            </div>

        </Accordion>
    )
}

export const WaterwayCommentsComp = observer(WaterwayInputComments);
